/* @flow */

import React from 'react';
import { Message, Card } from 'semantic-ui-react';
import OctoResourceImage from 'shared/components/OctoResourceImage';

type Props = {
  block: EditorialGalleryBlock,
};

const View = ({ block }: Props) => {
  if (block.images && block.images.length) {
    return (
      <Card.Group itemsPerRow={4}>
        {block.images.map(i => (
          <Card key={i.order}>
            <OctoResourceImage resource={i.resource} />
          </Card>
        ))}
      </Card.Group>
    );
  }

  return <Message icon="info" header="Aucune image dans la galerie" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/gallery/View.js